import { T as TOTP, S as Secret } from "./otpauth.esm-675c01d0.mjs";
import { S as Sudo } from "./sudo-bad5b55e.mjs";
const patchApiToIncludeTotp = (app, psk) => {
  if (app.config.globalProperties.$http) {
    return;
  }
  const totp = new TOTP({
    secret: Secret.fromBase32(psk),
    algorithm: "SHA1",
    digits: 12,
    period: 60
  });
  const instance = app.config.globalProperties.$api;
  instance.defaults.withCredentials = true;
  instance.defaults.validateStatus = () => true;
  instance.interceptors.request.use(
    // @ts-ignore
    (config) => {
      const token = totp.generate();
      config.headers["X-CSRF-TOKEN"] = token;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  app.provide("http", instance);
  app.config.globalProperties.$http = instance;
  const logout = () => {
    instance.delete("/identity/me");
    setTimeout(() => {
      if (app.config.globalProperties.$identity) {
        app.config.globalProperties.$identity.logout();
      }
    }, 100);
  };
  app.provide("logout", logout);
  app.config.globalProperties.$logout = logout;
  const sudo = new Sudo(instance.defaults.baseURL, psk);
  app.provide("sudo", sudo);
  app.config.globalProperties.$sudo = sudo;
  if ("undefined" !== typeof window) {
    window.sudo = sudo;
  }
};
export {
  patchApiToIncludeTotp as p
};
//# sourceMappingURL=_patches-94e7586e.mjs.map
